export const offersAL = {
    shippingTitle : "TRANSPORT FALAS",
    shippingText1 : "Për porosi më shumë se ",
    shippingText2 : "€ transport falas!",
    cashTitle : "PAGUAJ GJATË DORËZIMIT",
    cashText : "Pagesë gjatë dorëzimit pa pagesë shtesë!",
    topSellers : "Më të Shiturat"
}
